export default "__VITE_ASSET__DKhWRzsM__"